import type { AudienceFilter, AudienceStateFilter } from "@/entities/audience"
import { contextChips, plural } from "@/entities/audience"
import { describeSegment } from "../ui/segment-filters"
import { describeVariableFilter } from "../ui/variable-filter"

const STATE_LABELS: Record<AudienceStateFilter, string> = {
	waiting: "кто ждёт ответа бота",
	idle: "кто закончил сценарий",
	blocked: "кто заблокировал бота",
}

/** Кому уйдёт рассылка: одной фразой. */
export function describeFilter(
	filter: AudienceFilter,
	tags: { id: string; name: string }[] = [],
	niches: { id: string; name: string }[] = [],
): string {
	if (filter.sessionIds?.length) {
		const count = filter.sessionIds.length
		return `Только отмеченные вручную: ${count} ${plural(count, ["пользователь", "пользователя", "пользователей"])}`
	}
	const context = contextChips(filter, tags)
		.filter((chip) => chip.key !== "state")
		.map((chip) => chip.label)
	const parts = [
		filter.state ? STATE_LABELS[filter.state] : "все пользователи бота",
		...context,
		...describeSegment(filter, niches),
		filter.variable && filter.op
			? describeVariableFilter({ variable: filter.variable, op: filter.op, value: filter.value })
			: null,
	].filter(Boolean)
	const text = parts.join(", ")
	return `${text.charAt(0).toUpperCase()}${text.slice(1)}`
}
